import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type DeleteTimelineEventDialogProps = {
  eventTitle: string;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  submitting: boolean;
};

export function DeleteTimelineEventDialog({
  eventTitle,
  onConfirm,
  onOpenChange,
  open,
  submitting,
}: DeleteTimelineEventDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("timeline.deleteDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("timeline.deleteDialog.body", {
              title: eventTitle,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>
            {t("timeline.deleteDialog.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction disabled={submitting} onClick={onConfirm}>
            {t("timeline.deleteDialog.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
